import { cn } from "../lib/cn";

export interface SpinnerProps {
	/** Диаметр кольца в px. 20 — внутри кнопки, 16 — в строке списка. */
	size?: number;
	thickness?: number;
	className?: string;
	label?: string;
}

/**
 * Кольцевой индикатор из продукта: дуга на 1.2s. Толщина и цвет берутся от
 * текста родителя (currentColor), поэтому спиннер одинаково читается и на
 * зелёной заливке кнопки, и на серой плашке.
 */
export function Spinner({ size = 20, thickness = 2, className, label }: SpinnerProps) {
	return (
		<span
			role="status"
			aria-label={label}
			aria-live="polite"
			className={cn("inline-block rounded-full border-line", className)}
			style={{
				width: size,
				height: size,
				borderWidth: thickness,
				borderStyle: "solid",
				borderTopColor: "currentColor",
				animation: "iec-spin 1.2s linear infinite",
			}}
		/>
	);
}
